import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function Table(theme: Theme) {
  return {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          position: 'relative',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: 'none',
          backgroundColor: theme.palette.background.paper,
          // Figures line up in columns and stop shifting width as values change.
          fontVariantNumeric: 'tabular-nums',
          // Lab row rhythm: 44px rows instead of MUI's 16px-padded 56px+.
          padding: '10px 16px',
        },
        // `root` above is composed after TableCell's own ownerState.size === 'small'
        // styling, so without this override the blanket padding would swallow the
        // size variant and make size="small" tables (Contacts list, import preview)
        // looser instead of tighter. This restores MUI's own small-cell padding.
        sizeSmall: {
          padding: '6px 16px',
        },
        head: {
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.paper,
          borderBottom: '1px solid',
          borderBottomColor: theme.palette.divider,
        },
        stickyHeader: {
          backgroundColor: theme.palette.background.paper,
          backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.neutral} 0%, ${theme.palette.background.neutral} 100%)`,
        },
        paddingCheckbox: {
          paddingLeft: theme.spacing(1),
        },
      },
    },
    MuiTablePagination: {
      defaultProps: {
        // backIconButtonProps: {
        //   size: 'small',
        // },
        // nextIconButtonProps: {
        //   size: 'small',
        // },
        SelectProps: {
          MenuProps: {
            MenuListProps: {
              sx: {
                '& .MuiMenuItem-root': {
                  ...theme.typography.body2,
                },
              },
            },
          },
        },
      },

      styleOverrides: {
        root: {
          borderTop: `solid 1px ${theme.palette.divider}`,
        },
        toolbar: {
          height: 52,
        },
        actions: {
          marginRight: theme.spacing(1),
        },
        select: {
          '&:focus': {
            borderRadius: theme.shape.borderRadius,
          },
        },
      },
    },
  }
}
